import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  width: 70px;\n  justify-content: center;\n  padding: 15px;\n  z-index: 1;\n  transition: none;\n\n  svg path {\n    transition: none;\n    stroke: ', ';\n  }\n\n  &:focus {\n    opacity: 1;\n  }\n\n  &:hover {\n    svg path {\n      fill: ', ';\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    &:hover {\n      svg path {\n        fill: none;\n      }\n    }\n  }\n\n  ', '\n  ', '\n'], ['\n  display: flex;\n  width: 70px;\n  justify-content: center;\n  padding: 15px;\n  z-index: 1;\n  transition: none;\n\n  svg path {\n    transition: none;\n    stroke: ', ';\n  }\n\n  &:focus {\n    opacity: 1;\n  }\n\n  &:hover {\n    svg path {\n      fill: ', ';\n    }\n  }\n\n  @media screen and (max-width: ', ') {\n    &:hover {\n      svg path {\n        fill: none;\n      }\n    }\n  }\n\n  ', '\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      opacity: 1;\n    '], ['\n      opacity: 1;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      svg path {\n        fill: ', ';\n        stroke: ', ';\n      }\n    '], ['\n      svg path {\n        fill: ', ';\n        stroke: ', ';\n      }\n    ']);

import styled, { css } from 'styled-components';

export var StyledBtn = styled.button(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.dormifyWhite;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.dormifyWhite;
}, function (theme) {
  return theme.tabletWidth;
}, function (_ref3) {
  var productPage = _ref3.productPage;
  return productPage && css(_templateObject2);
}, function (_ref4) {
  var isWishlistProduct = _ref4.isWishlistProduct,
      theme = _ref4.theme;
  return isWishlistProduct && css(_templateObject3, theme.dormifyWhite, theme.dormifyWhite);
});